import Marquee from "react-fast-marquee";

const ITEMS = [
  "Dignifyd Tech",
  "Talent Connect",
  "Dignifyd Digital",
  "Enterprise Solutions",
  "Dignifyd Data Labs",
];

export default function EntityMarquee() {
  return (
    <div
      data-testid="entity-marquee"
      className="border-y border-white/10 bg-surface/60 py-6"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8">
            <span className="font-heading text-2xl font-medium tracking-tight text-white/80 sm:text-3xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
